import React, { createContext } from "react";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import PropTypes from "prop-types";

export const BlocksContext = createContext();
const { Provider } = BlocksContext;

const SelectBlocks = ({
  children,
  onChange,
  idBlock,
  blocks,
  selectedBlock
}) => {
  return (
    <Provider
      value={{
        idBlock,
        selectedBlock: selectedBlock ?? idBlock
      }}
    >
      <FormControl fullWidth disabled={selectedBlock}>
        <InputLabel required id="manzanas-label">
          Manzanas
        </InputLabel>
        <Select
          labelId="manzanas-label"
          id="manzanas"
          onChange={e => onChange(e.target.value)}
          value={idBlock || ""}
        >
          {blocks && blocks.length > 0 ? (
            blocks.map(item => (
              <MenuItem key={"blk-" + item.ID_MANZANA} value={item.ID_MANZANA}>
                {item.CODIGO}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled value="">
              Sin opciones disponibles
            </MenuItem>
          )}
        </Select>
      </FormControl>
      {children}
    </Provider>
  );
};

SelectBlocks.propTypes = {
  children: PropTypes.element,
  onChange: PropTypes.func,
  idBlock: PropTypes.number,
  blocks: PropTypes.array,
  selectedBlock: PropTypes.bool
};

export default SelectBlocks;
